import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

export const monthlyProgressListGet = (listData: any) => {
	const data = {
		GetMonthlyReportProgressToken: listData,
	};
	const url = `${API_URL}PostMonthlyProgressReport`;
	return makeApiCall(url, data);
};
